import { ApiAISummaryResult } from "@/types/ai/ai.types.ts";
import { Avatar, Button, HtmlViewer, LinkButtonTo, Stack, Text } from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export interface AISummaryProps {
  ai_summary: ApiAISummaryResult;
  caption?: string;
  showMore?: boolean;
  showAllResponsesButton?: boolean;
}

export const AISummary = ({
  ai_summary,
  caption,
  showMore = false,
  showAllResponsesButton = false,
}: AISummaryProps) => {
  const { t } = useTranslation();

  const [isShowOverview, setIsShowOverview] = useState(!showMore && !!ai_summary.overview);

  return (
    <Stack
      gap={"sm"}
      className={"border border-violet/40 rounded-xs p-4 bg-violet/10"}
      style={{
        boxShadow: `0px 16px 96px 0px color-mix(in srgb, var(--color-violet) 24%, transparent),
                    0px 4px 8px 0px hsla(0, 0%, 0%, 0.08)`,
      }}
    >
      <Stack direction={"horizontal"} items={"center"} gap={"sm"}>
        <Avatar emoji={":crystal_ball:"} className={"bg-violet/60"} />
        <Text className={"font-semibold text-violet"}>{t("ai:ai_summary_highlights_title")}:</Text>
        <Text className={"text-violet"}>
          {caption || t("ai:ai_summary_highlights_description")}
        </Text>
      </Stack>

      {isShowOverview ? (
        <Stack gap={"md"}>
          <HtmlViewer content={ai_summary.overview} />
          <LinkButtonTo
            onClick={(event) => {
              setIsShowOverview(false);
              event.preventDefault();
              event.stopPropagation();
            }}
          >
            {t("common:show_more")}
          </LinkButtonTo>
        </Stack>
      ) : (
        <HtmlViewer content={ai_summary.text} />
      )}
      {showAllResponsesButton && (
        <Stack direction={"horizontal"}>
          <Button variant={"secondary"}>{t("common:view_all_responses")}</Button>
        </Stack>
      )}
    </Stack>
  );
};
